const BASE_PARAMETER_MODEL = {
  image: {
    label: "Logo :",
    type: "text",
    default:
      "https://front-end-zevoice.s3.eu-west-2.amazonaws.com/website/img/AlloReviewW.svg",
  },
  backgroundColor: {
    label: "Couleur de fond :",
    type: "color",
    default: "#021427",
  },
  textColor: {
    label: "Couleur du texte :",
    type: "color",
    default: "white",
  },
  languages: {
    label: "Langues :",
    type: "array",
    default: [
      { name: "Anglais", value: "en" },
      { name: "Français", value: "fr" },
    ],
    elemModel: {
      name: {
        label: "Language :",
        type: "text",
        default: "",
      },
      value: {
        label: "Code langue :",
        type: "text",
        default: "",
      },
    },
  },
  additionalData: {
    label: "Données additionnelles :",
    type: "code",
    default: "{}",
  },
};

const WEB_APP_API_URL = process.env.REACT_APP_API_URL;

export { BASE_PARAMETER_MODEL, WEB_APP_API_URL };
